import Injector from 'vue-inject';
import Debug from '@/util/debug';
import { IDB_TABLE_LOCATIONS } from '@/util/constants';
import idb from '@/util/indexed-db';

const debug = Debug('service:Reach');

// we multiply all reach from FAM with 0.66 to prevent situations
// where we need to reach every single person in target area
// which is almost impossible
const GLOBAL_REACH_MULTIPLIER = 0.66;

export default class ReachService {
  constructor(aas, oms) {
    this.adApiService = aas;
    this.offlineModeService = oms;
    this.cache = {};
  }

  getReachFromApi(target) {
    debug.info('getting reach from api for target: %o', target);

    const requestData = Object.assign({}, target);

    requestData.locations = requestData.locations.map(l => ({
      type: l.type,
      name: l.name,
      facebook_id: l.facebookId,
      latitude: l.lat,
      longitude: l.lng,
    }));

    requestData.ages = [requestData.ages];

    return this.adApiService.potentialReach(requestData)
      .then(r => (Array.isArray(r) ? r[0] : r))
      .then(r => ({
        ...r,
        users: Math.floor(r.users * GLOBAL_REACH_MULTIPLIER),
      }));
  }

  // eslint-disable-next-line class-methods-use-this
  getReachFromOffline(target) {
    debug.info('getting reach from offline locations for target: %o', target);

    const requestData = Object.assign({}, target);
    const locationFbIds = requestData.locations.map(l => l.facebookId);

    return idb[IDB_TABLE_LOCATIONS]
      .where('fb_city_id')
      .anyOf(locationFbIds)
      .toArray()
      .then(res => {
        debug.info('offline locations reach: %o', res);
        const users = res.reduce((acc, l) => {
          let reach = 0;
          const from = requestData.ages.from;
          const to = requestData.ages.to;
          const reachData = JSON.parse(l.potential_reach_age);
          Object.keys(reachData).forEach(k => {
            const tmp = k.split('_').map(a => Number(a));
            if (tmp[0] >= from && tmp[1] <= to && (tmp[0] !== from || tmp[1] !== to)) {
              // There are users within selected age group
              let genderKey = 'all';
              if (requestData.genders.length === 1) {
                genderKey = requestData.genders.indexOf('m') >= 0 ? 'males' : 'females';
              }

              if (reachData[k][genderKey]
                  && reachData[k][genderKey][requestData.radius]) {
                reach += reachData[k][genderKey][requestData.radius];
              }
            }
          });
          return acc + reach;
        }, 0);

        return {
          users: Math.floor(users * GLOBAL_REACH_MULTIPLIER),
          bid_amount_min: 0,
          bid_amount_max: 0,
          cpm: 0,
        };
      });
  }

  getReach(target) {
    if (!target.locations.length) {
      return new Promise(resolve => resolve({
        users: 0,
        bid_amount_min: 0,
        bid_amount_max: 0,
        cpm: 0,
      }));
    }
    const online = this.offlineModeService.getStatus();
    const targetCacheKey = JSON.stringify({ target, online });

    if (targetCacheKey in this.cache) {
      return new Promise(resolve => resolve(this.cache[targetCacheKey]));
    }

    const promise = !online ? this.getReachFromOffline(target) : this.getReachFromApi(target);
    return promise
      .then(r => {
        if (r.errors) {
          throw r.errors[0];
        }
        return r;
      })
      .then(r => { this.cache[targetCacheKey] = r; return r; });
  }
}

Injector.service('reachService', ['adApiService', 'offlineModeService'], ReachService);



// WEBPACK FOOTER //
// ./src/services/ReachService.js